import { autoinject } from 'aurelia-framework';
import { IState } from "../../store/state";
import { pluck } from "rxjs/operators";
import { connectTo } from "aurelia-store";
import { applicationLogger } from "../../logging/logger";

//@connectTo<IState>({
//	target: 'applicationState',
//	selector: {
//		locationState: (store) => store.state.pipe(pluck('locationState'))
//	}
//})
@autoinject
export class Devices {
	//applicationState: IState;
	//constructor() {

	//}

	//bind(bindingContext: any, overrideContext: any) {

	//}

	attached() {

	}

	//detached() {

	//}
}